import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import banner01Img from "images/banner/09_red.png";
import banner02Img from "images/banner/10_green.png";
import banner03Img from "images/banner/11.png";
import banner04Img from "images/banner/12.png";

import bgImg01 from "images/hero1.jpg";
import bgImg02 from "images/hero2.jpg";

const Hero = () => {
	const swiperRef = useRef(null);

	return (
		<div className="cleaning-home-banner-wrapper-one">
			<div className="swiper mySwiper-banner-cleaning">
				<Swiper
					onSwiper={(swiper) => (swiperRef.current = swiper)}
					modules={[Navigation]}
					loop={true}>
					<SwiperSlide>
						<div className="main-cleaning-wrapper-main-swiper">
							<div className="shape-area-left">
								<img
									className="full"
									src={banner02Img}
									alt="shape-image"
									style={{ opacity: 0.4 }}
								/>
								<img
									className="left-b"
									src={banner03Img}
									alt="shape-image"
									style={{ opacity: 0.2 }}
								/>
								<img
									className="left-t"
									src={banner04Img}
									alt="shape-image"
									style={{ opacity: 0.2 }}
								/>
								<img className="right-b" src={banner01Img} alt="shape-image" />
							</div>
							<div
								className="banner-cleaning-area"
								style={{
									backgroundImage: `linear-gradient(rgba(0,0,0,0.72), rgba(0,0,0,0.72)), url(${bgImg01})`,
								}}>
								<div className="container">
									<div className="row">
										<div className="col-lg-12">
											<div className="banner-cleaning-content text-center">
												<span className="pre">
													Cartongesso, isolamento e ristrutturazioni a Codogno
												</span>
												<h1 className="title">
													Trasforma i tuoi spazi con <br /> cartongesso su misura
												</h1>
												<a href="#contact" className="rts-btn btn-primary">
													Chiedi un preventivo
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<div className="main-cleaning-wrapper-main-swiper ">
							<div className="shape-area-left">
								<img
									className="full"
									src={banner02Img}
									alt="shape-image"
									style={{ opacity: 0.4 }}
								/>
								<img
									className="left-b"
									src={banner03Img}
									alt="shape-image"
									style={{ opacity: 0.2 }}
								/>
								<img
									className="left-t"
									src={banner04Img}
									alt="shape-image"
									style={{ opacity: 0.2 }}
								/>
								<img className="right-b" src={banner01Img} alt="shape-image" />
							</div>
							<div
								className="banner-cleaning-area"
								style={{
									backgroundImage: `linear-gradient(rgba(0,0,0,0.72), rgba(0,0,0,0.72)), url(${bgImg02})`,
								}}>
								<div className="container">
									<div className="row">
										<div className="col-lg-12">
											<div className="banner-cleaning-content text-center">
												<span className="pre">Esperti in cartongesso e soluzioni per interni</span>
												<h1 className="title">
													Pareti in cartongesso e<br /> ristrutturazioni di qualità
												</h1>
												<a href="#contact" className="rts-btn btn-primary">
													Chiedi un preventivo
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</SwiperSlide>
				</Swiper>
				<div
					className="swiper-button-next"
					onClick={() => swiperRef.current?.slidePrev()}></div>
				<div
					className="swiper-button-prev"
					onClick={() => swiperRef.current?.slideNext()}></div>
			</div>
		</div>
	);
};

export default Hero;
